
import {getInformationUsers} from '../api/getInformationUsers';
import {setGetInformationUsersAction, setGetInformationSpinAction, setGetDetalizationSpinAction, setGetNewUsersAction} from '../action';

const setGetInformationUsers = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getInformationUsers(params);

            if (data.status === 'success') {
                dispatch(setGetInformationUsersAction(data.data.count)); 
                dispatch(setGetInformationSpinAction(data.countBet));
                dispatch(setGetDetalizationSpinAction(data.detalizationBet));
                dispatch(setGetNewUsersAction(data.usersNew.count));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetInformationUsers
}